import "reflect-metadata";

import "./App.css";
import Pages from "./pages/index.jsx";
import AuthProvider from "./auth/provider";

import { LicenseInfo } from "@mui/x-license";
import { getAuthToken } from "./auth/storage";

LicenseInfo.setLicenseKey(
  "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
);

function App() {
  return (
    <AuthProvider initial={getAuthToken()}>
      <Pages />
    </AuthProvider>
  );
}

export default App;
